<template>
    <div class="imagem-nao-disponivel">
        <i class="fa fa-camera"></i>
        <p>Imagem não disponível</p>
    </div>
</template>

<script>
    export default {
        
    }
</script>

<style lang="less" scoped>
    .imagem-nao-disponivel {
        text-align: center;
        
        i {
            color: #8f9fb5;
            font-size: 72px;
            padding: 15px;
        }
    }
</style>